import * as commonTypes from '../services/examActionType';
import * as tatTypes from '../TAT/services/TATActionType';
import * as unreadTypes from '../Unread/services/UnreadActionType';
import * as rawExamTypes from '../rawExamData/services/RawExamActionType';
import * as miscellaneousTypes from '../miscellaneousSiteData/services/miscellaneousActionType';
import * as readTypes from '../read/services/ReadActionType';
import * as examDataTypes from '../examData/services/examDataActionType';
import * as rawExamDataTypes from '../rawExamData/services/rawExamDataActionType';
import * as examMetricsTypes from '../examMetrics/services/examMetricsActionType';
import initialState from '../../../store/initialState';

const types = { ...commonTypes, ...tatTypes, ...unreadTypes, ...miscellaneousTypes, ...readTypes, ...examDataTypes, ...rawExamTypes, ...rawExamDataTypes, ...examMetricsTypes };

const examReducer = (state = initialState.exam, action) => {
    switch (action.type) {

        //RawExamData cases
        case types.FETCH_RAW_EXAM_DATA_REQUEST:
            return { ...state, isRawExamDataLoading: true, };
        case types.FETCH_RAW_EXAM_DATA_SUCCESS:
            return { ...state, isRawExamDataLoading: false, rawExamData: action.payload || {} };
        case types.FETCH_RAW_EXAM_DATA_FAILURE:
            return { ...state, isRawExamDataLoading: false, rawExamData: {} };

        case types.REFRESH_RAW_EXAM_DATA_REQUEST:
            return { ...state, isRawExamDataLoading: true, };
        case types.REFRESH_RAW_EXAM_DATA_SUCCESS:
            return { ...state, isRawExamDataLoading: false, rawExamData: action.payload?.lstRawExamData || [] };
        case types.REFRESH_RAW_EXAM_DATA_FAILURE:
            return { ...state, isRawExamDataLoading: false, rawExamData: [] };

        case types.EXPORT_RAW_EXAM_DATA_REQUEST:
            return { ...state, isExportingRawExamData: true };
        case types.EXPORT_RAW_EXAM_DATA_SUCCESS:
        case types.EXPORT_RAW_EXAM_DATA_FAILURE:
            return { ...state, isExportingRawExamData: false };

        case types.CLEAR_RAW_EXAM_DATA:
            return { ...state, isRawExamDataLoading: false, rawExamData: initialState.exam.rawExamData };

        //read data cases 
        case types.FETCH_EXAM_DATA_READ_REQUEST:
            return { ...state, isReadExamDataLoading: true, };
        case types.FETCH_EXAM_DATA_READ_SUCCESS:
            return { ...state, isReadExamDataLoading: false, readData: action.payload || [] };
        case types.FETCH_EXAM_DATA_READ_FAILURE:
            return { ...state, isReadExamDataLoading: false, readData: [] };
        case types.EXPORT_EXAM_DATA_READ_REQUEST:
            return { ...state, isReadExamDataLoading: false, readData: [] };

        //Unread Data cases
        case types.FETCH_UNREAD_EXAM_DATA_REQUEST:
            return { ...state, isUnreadExamDataLoading: true, };
        case types.FETCH_UNREAD_EXAM_DATA_SUCCESS:
            return { ...state, isUnreadExamDataLoading: false, unreadExamData: action.payload || {} };
        case types.FETCH_UNREAD_EXAM_DATA_FAILURE:
            return { ...state, isUnreadExamDataLoading: false, unreadExamData: {} };

        //TAT Data cases
        case types.FETCH_TAT_DATA_REQUEST:
            return { ...state, isTatDataLoading: true, };
        case types.FETCH_TAT_DATA_SUCCESS:
            return { ...state, isTatDataLoading: false, tatData: action.payload || {} };
        case types.FETCH_TAT_DATA_FAILURE:
            return { ...state, isTatDataLoading: false, tatData: {} };

        // Miscellaneous Site Data cases
        case types.FETCH_MISC_SITE_DATA_REQUEST:
            return { ...state, isMiscSiteDataLoading: true };
        case types.FETCH_MISC_SITE_DATA_SUCCESS:
            return { ...state, isMiscSiteDataLoading: false, miscSiteData: action.payload?.lstMiscSites || [] };
        case types.FETCH_MISC_SITE_DATA_FAILURE:
            return { ...state, isMiscSiteDataLoading: false, miscSiteData: [] };
        case types.CLEAR_MISC_SITE_DATA:
            return { ...state, isMiscSiteDataLoading: false, miscSiteData: initialState.exam.miscSiteData };

        case types.FETCH_SITES_DROPDOWN_REQUEST:
            return { ...state, isSitesDropdownLoading: true };
        case types.FETCH_SITES_DROPDOWN_SUCCESS:
            return { ...state, isSitesDropdownLoading: false, sitesDropdown: action.payload || [] };
        case types.FETCH_SITES_DROPDOWN_FAILURE:
            return { ...state, isSitesDropdownLoading: false, sitesDropdown: [] };

        case types.FETCH_PRACTICE_SITE_MAPPING_REQUEST:
            return { ...state, isPracticeSiteMappingLoading: true };
        case types.FETCH_PRACTICE_SITE_MAPPING_SUCCESS:
            return { ...state, isPracticeSiteMappingLoading: false, practiceSiteMapping: action.payload || {} };
        case types.FETCH_PRACTICE_SITE_MAPPING_FAILURE:
            return { ...state, isPracticeSiteMappingLoading: false, practiceSiteMapping: {} };

        case types.SAVE_UPDATE_MISC_SITES_REQUEST:
            return { ...state, isSavingMiscSites: true };
        case types.SAVE_UPDATE_MISC_SITES_SUCCESS:
            return { ...state, isSavingMiscSites: false, saveResponse: action.payload };
        case types.SAVE_UPDATE_MISC_SITES_FAILURE:
            return { ...state, isSavingMiscSites: false, saveError: action.payload };
        // Miscellaneous Site Data cases end
        // return { ...state, isRawExamDataLoading: false, rawExamData: [] };

        //Examdata cases
        case types.FETCH_EXAM_DATA_REQUEST:
            return { ...state, isExamDataLoading: true, };
        case types.FETCH_EXAM_DATA_SUCCESS: {
            const tab = action.meta?.tab;
            const data = action.payload || {};
            return {
                ...state,
                isExamDataLoading: false,
                examData: data,
                examDataByTab: tab
                    ? { ...state.examDataByTab, [tab]: { data, filterKey: action.meta?.filterKey || '' } }
                    : state.examDataByTab
            };
        }
        case types.FETCH_EXAM_DATA_FAILURE: {
            const tab = action.meta?.tab;
            const nextByTab = { ...state.examDataByTab };
            if (tab) delete nextByTab[tab];
            return { ...state, isExamDataLoading: false, examData: {}, examDataByTab: nextByTab };
        }
        case types.INVALIDATE_EXAM_DATA_CACHE: {
            // Keep rendered rows, but drop the keys so the next tab visit refetches.
            const staleByTab = Object.entries(state.examDataByTab || {}).reduce((acc, [tab, entry]) => {
                acc[tab] = { ...entry, filterKey: '' };
                return acc;
            }, {});
            return { ...state, examDataByTab: staleByTab };
        }
        case types.CLEAR_EXAM_DATA:
            return {
                ...state,
                isExamDataLoading: false,
                examData: initialState.exam.examData,
                examDataByTab: initialState.exam.examDataByTab,
                saveBatchRecordExamDataResponse: initialState.exam.saveBatchRecordExamDataResponse,
            };

        // Unassigned Exam Data Count (tab badge, independent of the active tab)
        case types.FETCH_UNASSIGNED_EXAM_DATA_COUNT_REQUEST:
            return { ...state, isUnassignedExamDataCountLoading: true };
        case types.FETCH_UNASSIGNED_EXAM_DATA_COUNT_SUCCESS:
            return { ...state, isUnassignedExamDataCountLoading: false, unassignedExamDataCount: action.payload || 0 };
        case types.FETCH_UNASSIGNED_EXAM_DATA_COUNT_FAILURE:
            return { ...state, isUnassignedExamDataCountLoading: false };

        // Export Calculated Exam Data To CSV
        case types.EXPORT_CALCULATED_EXAM_DATA_REQUEST:
            return { ...state, isExportingCalculatedExamData: true };
        case types.EXPORT_CALCULATED_EXAM_DATA_SUCCESS:
        case types.EXPORT_CALCULATED_EXAM_DATA_FAILURE:
            return { ...state, isExportingCalculatedExamData: false };


        case types.FETCH_EXAM_DROPDOWN_OPTIONS_REQUEST:
            return {
                ...state,
                isExamDropdownOptionsLoading: true
            };

        case types.FETCH_EXAM_DROPDOWN_OPTIONS_SUCCESS:
            return {
                ...state,
                isExamDropdownOptionsLoading: false,
                siteDDList: action.payload?.siteDDlist || [],
                radDDList: action.payload?.radDDlist || [],
                priorityGroupDDList: action.payload?.priorityGroupDDlist || [],
                priorityDDList: action.payload?.priorityDDlist || [],
                subspecialityDDList: action.payload?.subspecialityDDlist || [],
                readDateDDList: action.payload?.readDateDDList || [],
                readHourDDList: action.payload?.readHourDDList || [],
                unreadDateDDList: action.payload?.unreadDateDDlist || [],
                unreadHourDDList: action.payload?.unreadHourDDlist || [],
                accessionDDList: action.payload?.accessionDDlist || [],
                recordDateDDList: action.payload?.recordDateDDlist || [],
                examDropdownOptions: action.payload || {}
            };

        case types.FETCH_EXAM_DROPDOWN_OPTIONS_FAILURE:
            return {
                ...state,
                isExamDropdownOptionsLoading: false,
                siteDDList: [],
                radDDList: [],
                priorityGroupDDList: [],
                priorityDDList: [],
                subspecialityDDList: [],
                readDateDDList: [],
                readHourDDList: [],
                unreadDateDDList: [],
                unreadHourDDList: [],
                accessionDDList: [],
                recordDateDDList: [],
                examDropdownOptions: {}
            };

        //Recalculate Data cases
        case types.FETCH_RECALCULATE_DATA_REQUEST:
            return { ...state, isRecalculateDataLoading: true, };
        case types.FETCH_RECALCULATE_DATA_SUCCESS:
            return { ...state, isRecalculateDataLoading: false, recalculateData: action.payload?.listExamDataReCalculate || [] };
        case types.FETCH_RECALCULATE_DATA_FAILURE:
            return { ...state, isRecalculateDataLoading: false, recalculateData: {} };

        //Exam Data Record Date cases
        case types.UPDATE_EXAM_DATA_RECORD_DATE_REQUEST:
            return { ...state, isUpdatingRecordDate: true, };
        case types.UPDATE_EXAM_DATA_RECORD_DATE_SUCCESS:
            return { ...state, isUpdatingRecordDate: false, examDataRecordDate: action.payload || {} };
        case types.UPDATE_EXAM_DATA_RECORD_DATE_FAILURE:
            return { ...state, isUpdatingRecordDate: false };

        //Save Batch Record Exam Data cases
        case types.SAVE_BATCH_RECORD_EXAM_DATA_REQUEST:
            return { ...state, isSavingBatchRecordExamData: true, };
        case types.SAVE_BATCH_RECORD_EXAM_DATA_SUCCESS:
            return { ...state, isSavingBatchRecordExamData: false, saveBatchRecordExamDataResponse: action.payload };
        case types.SAVE_BATCH_RECORD_EXAM_DATA_FAILURE:
            return { ...state, isSavingBatchRecordExamData: false, saveBatchRecordExamDataError: action.payload };

        //Get batch by record date
        case types.FETCH_EXAM_DATA_BATCH_REQUEST:
            return { ...state, isFetchingExamDataBatch: true };
        case types.FETCH_EXAM_DATA_BATCH_SUCCESS:
            return { ...state, isFetchingExamDataBatch: false, examDataBatch: action.payload || {} };
        case types.FETCH_EXAM_DATA_BATCH_FAILURE:
            return { ...state, isFetchingExamDataBatch: false, examDataBatchError: action.payload };

        // Save Batch Record
        case types.SAVE_BATCH_RECORD_REQUEST:
            return { ...state, isSavingBatchRecord: true };
        case types.SAVE_BATCH_RECORD_SUCCESS:
            return { ...state, isSavingBatchRecord: false, saveBatchRecordResponse: action.payload };
        case types.SAVE_BATCH_RECORD_FAILURE:
            return { ...state, isSavingBatchRecord: false, saveBatchRecordError: action.payload };

        // Check Recalculation
        case types.CHECK_RECALCULATION_REQUEST:
            return { ...state, isCheckingRecalculation: true };
        case types.CHECK_RECALCULATION_SUCCESS:
            return { ...state, isCheckingRecalculation: false, checkRecalculationData: action.payload || {} };
        case types.CHECK_RECALCULATION_FAILURE:
            return { ...state, isCheckingRecalculation: false, checkRecalculationError: action.payload };

        // Re Calculate Exam Data Details
        case types.RE_CALCULATE_EXAM_DATA_DETAILS_REQUEST:
            return { ...state, isRecalculateDataLoading: true, };
        case types.RE_CALCULATE_EXAM_DATA_DETAILS_SUCCESS:
            return { ...state, isRecalculateDataLoading: false, reCalculateExamDataDetails: action.payload || {} };
        case types.RE_CALCULATE_EXAM_DATA_DETAILS_FAILURE:
            return { ...state, isRecalculateDataLoading: false, reCalculateExamDataDetailsError: action.payload };
        case types.RESET_CHECK_RECALCULATION:
            return {
                ...state,
                checkRecalculationData: null,
                checkRecalculationError: null
            };

        // Get Unassigned Combinations
        case types.FETCH_UNASSIGNED_COMBINATIONS_REQUEST:
            return { ...state, isUnassignedCombinationsLoading: true };
        case types.FETCH_UNASSIGNED_COMBINATIONS_SUCCESS:
            return { ...state, isUnassignedCombinationsLoading: false, unassignedCombinations: action.payload?.listUnassignedCombinations || [] };
        case types.FETCH_UNASSIGNED_COMBINATIONS_FAILURE:
            return { ...state, isUnassignedCombinationsLoading: false, unassignedCombinations: [], unassignedCombinationsError: action.payload };

        // Check Worklist Assignments
        case types.CHECK_WORKLIST_ASSIGNMENTS_REQUEST:
            return {
                ...state,
                isCheckingWorklistAssignments: true
            };
        case types.CHECK_WORKLIST_ASSIGNMENTS_SUCCESS:
            return {
                ...state,
                isCheckingWorklistAssignments: false,
                checkWorklistAssignmentsData: action.payload || {},
                checkedWorklistExamDataIds: action.payload?.listWorklistCombinations || [],
                checkedWorklistMappableCount: action.payload?.MappableCount || 0
            };
        case types.CHECK_WORKLIST_ASSIGNMENTS_FAILURE:
            return {
                ...state,
                isCheckingWorklistAssignments: false,
                checkWorklistAssignmentsData: {},
                checkedWorklistExamDataIds: [],
                checkedWorklistMappableCount: 0,
                checkWorklistAssignmentsError: action.payload
            };

        // Save Worklist Mapping
        case types.SAVE_WORKLIST_MAPPING_REQUEST:
            return {
                ...state,
                isSavingWorklistMapping: true
            };
        case types.SAVE_WORKLIST_MAPPING_SUCCESS:
            return {
                ...state,
                isSavingWorklistMapping: false,
                saveWorklistMappingResponse: action.payload || {}
            };
        case types.SAVE_WORKLIST_MAPPING_FAILURE:
            return {
                ...state,
                isSavingWorklistMapping: false,
                saveWorklistMappingResponse: {},
                saveWorklistMappingError: action.payload
            };

        case types.SAVE_WORKLIST_MAPPING_UPDATE_REQUEST:
            return {
                ...state,
                isSavingWorklistMappingUpdate: true
            };
        case types.SAVE_WORKLIST_MAPPING_UPDATE_SUCCESS:
            return {
                ...state,
                isSavingWorklistMappingUpdate: false,
                saveWorklistMappingUpdateResponse: action.payload || {}
            };
        case types.SAVE_WORKLIST_MAPPING_UPDATE_FAILURE:
            return {
                ...state,
                isSavingWorklistMappingUpdate: false,
                saveWorklistMappingUpdateResponse: {},
                saveWorklistMappingUpdateError: action.payload
            };

        // Exam Metrics Matrix
        case types.FETCH_EXAM_METRICS_MATRIX_REQUEST:
            return { ...state, isExamMetricsDataLoading: true };
        case types.FETCH_EXAM_METRICS_MATRIX_SUCCESS:
            return {
                ...state,
                isExamMetricsDataLoading: false,
                examMetricsData: action.payload || {}
            };
        case types.FETCH_EXAM_METRICS_MATRIX_FAILURE:
            return {
                ...state,
                isExamMetricsDataLoading: false,
                examMetricsData: {},
                examMetricsError: action.payload
            };
        case types.EXPORT_EXAM_METRICS_MATRIX_REQUEST:
            return { ...state, isExportingExamMetricsMatrix: true };
        case types.EXPORT_EXAM_METRICS_MATRIX_SUCCESS:
        case types.EXPORT_EXAM_METRICS_MATRIX_FAILURE:
            return { ...state, isExportingExamMetricsMatrix: false };
        case types.CLEAR_EXAM_METRICS_DATA:
            return { ...state, isExamMetricsDataLoading: false, examMetricsData: initialState.exam.examMetricsData };

        // Exam Metrics Dropdown
        case types.FETCH_EXAM_METRICS_DROPDOWN_REQUEST:
            return { ...state, isExamMetricsDropdownLoading: true };
        case types.FETCH_EXAM_METRICS_DROPDOWN_SUCCESS:
            return {
                ...state,
                isExamMetricsDropdownLoading: false,
                examMetricsDropdownOptions: action.payload || {},
                examMetricSites: action.payload?.Sites || [],
                examMetricSiteStatus: action.payload?.SiteStatus || [],
                examMetricSiteCoverageType: action.payload?.SiteCoverageType || [],
                examMetricPriorityBucket: action.payload?.PriorityBucket || [],
                examMetricPriority: action.payload?.Priority || [],
                examMetricModality: action.payload?.Modality || [],
                examMetricSubSpeciality: action.payload?.SubSpeciality || [],
                examMetricWorkList: action.payload?.WorkList || []
            };
        case types.FETCH_EXAM_METRICS_DROPDOWN_FAILURE:
            return {
                ...state,
                isExamMetricsDropdownLoading: false,
                examMetricsDropdownOptions: {},
                examMetricSites: [],
                examMetricSiteStatus: [],
                examMetricSiteCoverageType: [],
                examMetricPriorityBucket: [],
                examMetricPriority: [],
                examMetricModality: [],
                examMetricSubSpeciality: [],
                examMetricWorkList: [],
                examMetricsError: action.payload
            };

        // Exam Metrics Initial Date Range
        case types.FETCH_EXAM_METRICS_DATE_RANGE_REQUEST:
            return {
                ...state,
                isExamMetricsDateRangeLoading: true,
                examMetricsDateRangeError: null
            };
        case types.FETCH_EXAM_METRICS_DATE_RANGE_SUCCESS:
            return {
                ...state,
                isExamMetricsDateRangeLoading: false,
                examMetricsDateRange: action.payload || {},
                examMetricsDateRangeError: null
            };
        case types.FETCH_EXAM_METRICS_DATE_RANGE_FAILURE:
            return {
                ...state,
                isExamMetricsDateRangeLoading: false,
                examMetricsDateRange: {},
                examMetricsDateRangeError: action.payload
            };

        //common cases
        case types.UPDATE_EXAM_REDUCER:
            return { ...state, ...action.payload };

        default:
            return state;
    }
};

export default examReducer;